import BackendError from './backend-error';
import errors from 'src/static/errors.json';

export default abstract class ServerError extends BackendError {
  public name = 'ServerError';
  constructor(message = errors.genericError) {
    super(message);
  }
}
